import TokenService from "./TokenService";

class HttpInterceptor {
  load() {
    const that = this
    var originalFetch = fetch;
    fetch = function () {
      let newArguments = arguments;
      if (arguments.length > 1) {
        newArguments = that.setRequestConfigs(arguments)
      }

      return originalFetch.apply(this, newArguments);
    };
  }

  setRequestConfigs(request) {
    const tokenService = new TokenService();
    let usedAddToken = false;
    const { body } = request[1];

    if (body) {
      const bodyParams = JSON.parse(body);
      if (bodyParams.hasOwnProperty('addToken') && tokenService.hasToken()) {
        delete bodyParams['addToken'];
        bodyParams['token'] = tokenService.getToken();
        request[1].body = JSON.stringify(bodyParams);
        usedAddToken = true;
      }
    }

    if (request[1].headers) {
      const headers = new Headers(request[1].headers);
      if (headers.has('addToken') && tokenService.hasToken()) {
        headers.delete('addToken');
        const url = new URL(request[0]);
        url.searchParams.set('token', tokenService.getToken());
        request[0] = url.toString();
        request[1].headers = headers;
        usedAddToken = true;
      }
    }

    // Task 6 (huseyin_works/tasks/2026-08-05_zephy_backend_auth_gap/task_latest.md):
    // send a real Authorization header wherever addToken signaled intent to
    // authenticate, so backend routes protected by verifyUserToken.js (which reads
    // this header) work. The query-string/body `token` set above is left in place
    // too - handlers/nlp/history.js's /api/chat handler already reads
    // req.query.token directly, and removing it would break that.
    if (usedAddToken) {
      const headers = new Headers(request[1].headers || {});
      headers.set('Authorization', `Bearer ${tokenService.getToken()}`);
      request[1].headers = headers;
    }

    return request
  }
}

export default HttpInterceptor;
